import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import $ from 'jquery';
import AutoScopeStyles from '../../../Common/Utilities/Decorators/AutoScopeStylesDecorator';
import PopupLink from '../PopupLink.jsx';
import applyDecoratorsDoNotUseInNewCode from '../../Utilities/Decorators/ApplyDecorators';

class UserMenuView extends React.Component {
    render(){
        return (
            <div>
                <div className="who dropdown">
                    <span className="text"><i className="user icon"></i> { this.props.user.get('fullName') }</span>
                    <i className="dropdown icon"></i>
                    <ul className="menu">
                        <li className="item"><a href="/Online/PersonalDetails.aspx">Profile</a></li>
                        <li className="item"><a href="/App/Admin/Users/Me/ChangePassword">Change password</a></li>
                        <li className="item"><PopupLink href="/help" name="eCargoHelp" width={1035} height={600} menubar={true} resizable={true} scrollbar={true} location={false} left={180} modal={true}>Help</PopupLink></li>
                        <li className="item"><a href="/Online/Logout.aspx">Logout</a></li>
                    </ul>
                </div>
            </div>
        );
    }

    componentDidMount() {
        var menu = $('.dropdown', ReactDOM.findDOMNode(this));
        menu.dropdown({
            action: 'select'
        });
    }
}

UserMenuView.propTypes = {
    user: PropTypes.object
};

const withDecorators = applyDecoratorsDoNotUseInNewCode(AutoScopeStyles);

export default withDecorators(UserMenuView);
